import React, { useEffect, useState } from 'react';
import { apiService, KIOSK_AUTH_TOKEN_CHANGED_EVENT } from '@/services/apiService';
import { Header, HeaderProps } from './Header';

interface PublicHeaderProps extends Omit<HeaderProps, 'type'> {
  className?: string;
  /** When true, header fits compact chrome slot (`--wf-header-h`). */
  compact?: boolean;
}

/**
 * Header component for public pages (Home page)
 * Based on Figma design with normal type
 */
const PublicHeader: React.FC<PublicHeaderProps> = ({
  className = '',
  size = 'XL',
  compact = false,
  ...props
}) => {
  const [authed, setAuthed] = useState(() => apiService.isAuthenticated());

  useEffect(() => {
    const sync = () => setAuthed(apiService.isAuthenticated());
    window.addEventListener(KIOSK_AUTH_TOKEN_CHANGED_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(KIOSK_AUTH_TOKEN_CHANGED_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return (
    <Header
      type="normal"
      size={size}
      compact={compact}
      className={`public-header ${className}`}
      data-header-type="public"
      showNotificationBell={authed}
      {...props}
    />
  );
};

export default PublicHeader;
